import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt,
  faUsers,
  faTruck,
  faUserCircle,
  faUser,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    // Add your logout logic here (e.g., clear token, call API, etc.)
    console.log('Logging out...');
   localStorage.removeItem('token');
    navigate('/', { replace: true });
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src={logo} alt="Logo" className="logo" />
      </div>
      <div className="navbar-right">
        <Link to="/dashboard" className="nav-link">
          <FontAwesomeIcon icon={faTachometerAlt} /> Dashboard
        </Link>
        <Link to="/customers" className="nav-link">
          <FontAwesomeIcon icon={faUsers} /> Customers
        </Link>
        <Link to="/bookings" className="nav-link">
          <FontAwesomeIcon icon={faTruck} /> Bookings
        </Link>

        <div className="user-menu" ref={dropdownRef}>
          <button className="user-icon" onClick={() => setDropdownOpen(!dropdownOpen)}>
            <FontAwesomeIcon icon={faUserCircle} size="2x" />
          </button>

          {dropdownOpen && (
            <div className="dropdown">
              <Link to="/profile" className="dropdown-item">
                <FontAwesomeIcon icon={faUser} /> Profile
              </Link>
              <button onClick={handleLogout} className="dropdown-item logout">
                <FontAwesomeIcon icon={faSignOutAlt} /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
